import React, { Component } from "react";

class FeelingProud extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="fashion-atelier-hero"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="600"
        height="460"
        viewBox="0 0 600 460"
      >
        <title>fashion atelier</title>

        {/* ground shadows */}
        <ellipse cx="150" cy="410" rx="120" ry="9" fill="#e6e6e6" opacity="0.6" />
        <ellipse cx="434" cy="416" rx="55" ry="9" fill="#e6e6e6" opacity="0.6" />

        {/* ===== seated designer ===== */}
        <ellipse cx="55" cy="196" rx="29" ry="23" fill={theme.dark} />
        <circle cx="55" cy="209" r="25" fill="#ffb8b8" />
        <rect x="18" y="232" width="76" height="100" rx="22" fill={theme.imageHighlight} />

        {/* desk (drawn after the figure so it crops the lower body) */}
        <rect x="55" y="308" width="200" height="90" fill="#f2f2f2" />
        <rect x="45" y="298" width="220" height="16" rx="4" fill="#e6e6e6" />
        <rect x="70" y="345" width="55" height="4" rx="2" fill="#e6e6e6" />

        {/* sketchpad + sketching arm, on top of the desk */}
        <g transform="rotate(-7 130 285)">
          <rect x="72" y="248" width="118" height="86" rx="4" fill="#f2f2f2" stroke={theme.text} strokeWidth="2" />
          <circle cx="112" cy="272" r="8" fill="none" stroke={theme.text} strokeWidth="2" />
          <polygon points="98,320 108,296 126,296 136,320" fill="none" stroke={theme.text} strokeWidth="2" strokeLinejoin="round" />
          <line x1="150" y1="264" x2="176" y2="264" stroke={theme.text} strokeWidth="2" />
          <line x1="150" y1="278" x2="176" y2="278" stroke={theme.text} strokeWidth="2" />
          <line x1="150" y1="292" x2="168" y2="292" stroke={theme.text} strokeWidth="2" />
        </g>
        <line x1="92" y1="256" x2="150" y2="272" stroke="#ffb8b8" strokeWidth="16" strokeLinecap="round" />
        <circle cx="150" cy="272" r="10" fill="#ffb8b8" />
        <line x1="150" y1="272" x2="172" y2="282" stroke={theme.dark} strokeWidth="3" strokeLinecap="round" />

        {/* ===== dress form / mannequin ===== */}
        <rect x="430" y="336" width="8" height="76" fill="#e6e6e6" />
        <ellipse cx="434" cy="414" rx="42" ry="8" fill="#e6e6e6" />
        <rect x="424" y="192" width="16" height="14" fill="#e6e6e6" />
        <circle cx="432" cy="188" r="7" fill="#e6e6e6" />
        <polygon points="402,206 464,206 452,270 414,270" fill={theme.imageHighlight} />
        <polygon points="414,270 452,270 470,332 396,332" fill={theme.highlight} />
        <line x1="396" y1="286" x2="470" y2="286" stroke={theme.text} strokeWidth="2" strokeDasharray="3 5" opacity="0.6" />
        <line x1="400" y1="308" x2="466" y2="308" stroke={theme.text} strokeWidth="2" strokeDasharray="3 5" opacity="0.6" />
        <circle cx="414" cy="270" r="2.5" fill={theme.text} />
        <circle cx="452" cy="270" r="2.5" fill={theme.text} />
        <circle cx="433" cy="270" r="2.5" fill={theme.text} />

        {/* ===== sewing machine ===== */}
        <rect x="255" y="372" width="112" height="10" rx="3" fill="#e6e6e6" />
        <rect x="270" y="340" width="62" height="35" rx="8" fill={theme.dark} />
        <rect x="270" y="322" width="86" height="12" rx="6" fill={theme.dark} />
        <rect x="334" y="322" width="12" height="30" fill={theme.dark} />
        <line x1="279" y1="372" x2="279" y2="384" stroke={theme.dark} strokeWidth="3" strokeLinecap="round" />
        <circle cx="318" cy="330" r="8" fill={theme.imageHighlight} />
        <rect x="339" y="308" width="11" height="15" rx="2" fill={theme.imageHighlight} />
        <path d="M345,308 Q325,318 285,368" fill="none" stroke={theme.imageHighlight} strokeWidth="2" />

        {/* thread spool */}
        <rect x="205" y="386" width="20" height="26" rx="3" fill={theme.imageHighlight} />
        <ellipse cx="215" cy="386" rx="10" ry="4" fill={theme.highlight} />
        <ellipse cx="215" cy="412" rx="10" ry="4" fill={theme.highlight} />
        <line x1="207" y1="394" x2="223" y2="394" stroke={theme.text} strokeWidth="1.5" opacity="0.5" />
        <line x1="207" y1="401" x2="223" y2="401" stroke={theme.text} strokeWidth="1.5" opacity="0.5" />

        {/* scissors */}
        <line x1="176" y1="393" x2="203" y2="415" stroke={theme.text} strokeWidth="3" strokeLinecap="round" />
        <line x1="203" y1="393" x2="176" y2="415" stroke={theme.text} strokeWidth="3" strokeLinecap="round" />
        <circle cx="174" cy="391" r="5" fill="none" stroke={theme.text} strokeWidth="3" />
        <circle cx="205" cy="391" r="5" fill="none" stroke={theme.text} strokeWidth="3" />

        {/* fabric bolt */}
        <rect x="514" y="330" width="52" height="92" rx="10" fill={theme.highlight} />
        <ellipse cx="540" cy="330" rx="26" ry="10" fill={theme.imageHighlight} />
        <line x1="514" y1="362" x2="566" y2="362" stroke={theme.text} strokeWidth="2" opacity="0.3" />
        <line x1="514" y1="392" x2="566" y2="392" stroke={theme.text} strokeWidth="2" opacity="0.3" />
      </svg>
    );
  }
}

export default FeelingProud;
